import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { useApptekster } from '../contexts/ApptekstContext';
import * as api from '../utils/api';

export const ErrorBoundary: React.FC<{
    children?: React.ReactNode;
}> = ({ children }) => {
    const t = useApptekster();

    React.useEffect(() => {
        const handleError = (error: ErrorEvent) => api.loggFeil(error.message);
        window.addEventListener('error', handleError);
        return () => window.removeEventListener('error', handleError);
    }, []);

    return (
        <ReactErrorBoundary
            onError={(error, componentStack) =>
                api.loggFeil(
                    `${error.message}.\nKomponent-stack: ${componentStack.componentStack}`,
                )
            }
            fallback={
                <div className="container">
                    {t('personlig-kjennemerke.generell.feilmelding')}
                </div>
            }
        >
            {children}
        </ReactErrorBoundary>
    );
};
